import { css } from 'styled-components';

/**
 * White overlay hover effect for themed buttons.
 *
 * Layers a 12% white gradient over the button's background colour,
 * producing a subtle lightening effect that works with any channel brand colour.
 *
 * Why linear-gradient with identical stops instead of a flat colour:
 * CSS background shorthand requires gradient syntax to layer over a second
 * background value — a solid colour layer would need a separate background-color
 * declaration and couldn't be composed in one line. The identical 0%/100% stops
 * are intentional for broad browser compatibility.
 *
 * Why #ff007f as primary fallback: it's the base MDL brand colour — the overlay
 * provides the visual hover shift, so no separate pre-computed hover colour is needed.
 *
 * Why #e0e0e0 as secondary fallback: neutral grey ensures a visible button rather
 * than a white flash if a channel omits --theme-action-secondary.
 */
export const primaryButtonHover = css`
  background: linear-gradient(
      rgba(255, 255, 255, 0.12),
      rgba(255, 255, 255, 0.12)
    ),
    var(--theme-action-primary, #ff007f);
`;

export const secondaryButtonHover = css`
  background: linear-gradient(
      rgba(255, 255, 255, 0.12),
      rgba(255, 255, 255, 0.12)
    ),
    var(--theme-action-secondary, #e0e0e0);
`;

export const dangerButtonHover = css`
  background: linear-gradient(
      rgba(255, 255, 255, 0.12),
      rgba(255, 255, 255, 0.12)
    ),
    var(--color-red-700);
`;
